import {configureStore} from '@reduxjs/toolkit';
import {RootState} from '../types/common';
import menuItemsReducer from './menu/menuSlice';
import dictionariesReducer from './dictionariesSlice';
import wellNumberReducer from './wellNumberSlice';
import wellIdForStatusSlice from './wellIdForStatusSlice';
import notificationsReducer from './notifications/notificationsSlice';
import languageReducer from './language/languageSlice';
import reportsReducer from './reports/index';
import componentsReducer, {componentsReducerName} from './components/componentsSlice';
import {knbkApi} from './knbk';
export const selectMenu = (store: RootState) => store.menu;
export const selectDictionaries = (store: RootState) => store.dictionaries.data;
export const selectWellNumber = (store: RootState) => store.wellNumber.data || '';
export const selectNotification = (store: RootState) => store.notifications.data;
export const selectWellIdForStatus = (store: RootState) => store.wellIdForStatus.data || '';

const store = configureStore({
    reducer: {
        menu: menuItemsReducer,
        dictionaries: dictionariesReducer,
        wellNumber: wellNumberReducer,
        [componentsReducerName]: componentsReducer,
        [knbkApi.reducerPath]: knbkApi.reducer,
        notifications: notificationsReducer,
        reports: reportsReducer,
        language: languageReducer,
        wellIdForStatus: wellIdForStatusSlice,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(knbkApi.middleware),
});

export type AppState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
